"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PresenceBadge: function() {
        return _PresenceBadge.PresenceBadge;
    },
    presenceAvailableFilled: function() {
        return _presenceIcons.presenceAvailableFilled;
    },
    presenceAvailableRegular: function() {
        return _presenceIcons.presenceAvailableRegular;
    },
    presenceAwayFilled: function() {
        return _presenceIcons.presenceAwayFilled;
    },
    presenceAwayRegular: function() {
        return _presenceIcons.presenceAwayRegular;
    },
    presenceBadgeClassNames: function() {
        return _usePresenceBadgeStylesstyles.presenceBadgeClassNames;
    },
    presenceBlockedRegular: function() {
        return _presenceIcons.presenceBlockedRegular;
    },
    presenceBusyFilled: function() {
        return _presenceIcons.presenceBusyFilled;
    },
    presenceDndFilled: function() {
        return _presenceIcons.presenceDndFilled;
    },
    presenceDndRegular: function() {
        return _presenceIcons.presenceDndRegular;
    },
    presenceOfflineRegular: function() {
        return _presenceIcons.presenceOfflineRegular;
    },
    presenceOofRegular: function() {
        return _presenceIcons.presenceOofRegular;
    },
    presenceUnknownRegular: function() {
        return _presenceIcons.presenceUnknownRegular;
    },
    usePresenceBadgeStyles_unstable: function() {
        return _usePresenceBadgeStylesstyles.usePresenceBadgeStyles_unstable;
    },
    usePresenceBadge_unstable: function() {
        return _usePresenceBadge.usePresenceBadge_unstable;
    }
});
const _PresenceBadge = require("./PresenceBadge");
const _usePresenceBadge = require("./usePresenceBadge");
const _usePresenceBadgeStylesstyles = require("./usePresenceBadgeStyles.styles");
const _presenceIcons = require("./presenceIcons");
